import { c as _c } from "react/compiler-runtime";
import { AccordionProviderPersisted } from '@/uiComposites/interactive/accordion/AccordionProvider.client';
import { NoResults } from './NoResults';
import { ResultList, ResultListItem } from './ResultList';
import { ResultsHeading } from './ResultsHeading';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { stack } from '@/uiPrimitives/layout/stack';
import { ResultRendered } from '@/app/decisionToolArticle/_data/decisionToolRendered.types';
import { Sharesheet } from '@/sections/sharesheet/Sharesheet';
import { sharesheetButtonTranslations } from '@/sections/sharesheet/sharesheetTranslations';
import { Fragment } from 'react';
import { AccordionToggleButtons } from '@/uiComposites/interactive/accordion/AccordionToggleButtons.client';
import { useGivenAnswers } from '../_data/useGivenAnswers';
import { AnyRenderedQuestion } from '../_questions/question.types';
import { accordionToggleButtons } from './Results.css';
import { viewTransitionName } from '@/uiPrimitives/utility/viewTransitionNames.css';
export const UncategorisedResults = t0 => {
  const $ = _c(14);
  const {
    relevantResults,
    pageTitle,
    questions
  } = t0;
  const [givenAnswers] = useGivenAnswers(questions);
  let t1;
  if ($[0] !== relevantResults) {
    t1 = relevantResults.findIndex(_temp);
    $[0] = relevantResults;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firstAccordionIndex = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(stack({
      rowGap: "9 | asideBlockMargin"
    }), viewTransitionName({
      viewTransitionName: "decision-tool-result"
    }));
    t3 = <ResultsHeading />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== firstAccordionIndex || $[5] !== givenAnswers || $[6] !== questions || $[7] !== relevantResults) {
    t4 = relevantResults.length === 0 ? <NoResults /> : <AccordionProviderPersisted accordionKey="UncategorisedResults"><ResultList allQuestions={questions} givenAnswers={givenAnswers}>{relevantResults.map((result_0, index) => <Fragment key={result_0.id}>{firstAccordionIndex === index && <div className={classes(stack({}), accordionToggleButtons)}><AccordionToggleButtons itemsCount={relevantResults.filter(_temp2).length} /></div>}<ResultListItem result={result_0} headingLevel="h3" /></Fragment>)}</ResultList></AccordionProviderPersisted>;
    $[4] = firstAccordionIndex;
    $[5] = givenAnswers;
    $[6] = questions;
    $[7] = relevantResults;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== pageTitle) {
    t5 = <Sharesheet buttonLabel={sharesheetButtonTranslations["Share results"]} pageTitle={pageTitle} />;
    $[9] = pageTitle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <article className={t2}>{t3}{t4}{t5}</article>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
function _temp(result) {
  return result.type === "accordion";
}
function _temp2(result_1) {
  return result_1.type === "accordion";
}